import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames/bind'

import FullMap from '../../searchResults/components/FullMap/FullMap'
import setValue from '../../shared/actions/setValue'
import Button from '../../shared/Button';
import {pushOpenDatesFilter} from 'js/scenes/MainSearchBox/customEvents';
import fetchAvailabilities from 'js/components/searchResults/actions/fetchAvailabilities';
import HotelListCardMini from 'js/components/searchResults/components/HotelListCardMini';
import toggleGlobalLoader from 'js/components/Loader/actions/loaderActions';

import styles from './DestinationFullMap.module.scss'

const cx = classnames.bind(styles)
const btnText = drupalSettings?.destinationMap?.viewText;

const DestinationFullMap = function ({
  results,
  fetchAvailabilitiesAction,
  toggleGlobalLoaderAction,
  setValueAction,
  dates,
  apartments,
}) {
  const handleFMapClick = () => {
    setValueAction('fullMap', true)
  }

  const openDatesFilter = function () {
    setTimeout(() => {
      pushOpenDatesFilter();
    }, 500)
  }

  const getAvailabilities = async function () {
    toggleGlobalLoaderAction(true);
    await fetchAvailabilitiesAction();
    toggleGlobalLoaderAction(false);
  }

  useEffect(() => {
    if (!dates.dateIn || !dates.nbNight) {
      openDatesFilter();
    }
  }, []);

  useEffect(() => {
    getAvailabilities();
  }, [dates.dateIn, dates.nbNight, apartments]);

  return (
    <div className={cx('btn-holder')}>
      <FullMap
        fullMap
        isDestination
        itemComponent={HotelListCardMini}
      />
      {!!results?.length && (
        <Button
          type="button"
          className={cx('show-full-map')}
          color="black-reverse"
          theme="squared"
          onClick={handleFMapClick}
        >
          <i className="icon icon-map" />
          {btnText}
        </Button>
      )}
    </div>
  )
}

export default connect(({ main: { results }, url }) => ({
  results,
  dates: {
    dateIn: url?.parameters?.dateIn,
    nbNight: url?.parameters?.nbNight,
  },
  apartments: url?.parameters?.apartment,
}), {
  setValueAction: setValue,
  fetchAvailabilitiesAction: fetchAvailabilities,
  toggleGlobalLoaderAction: toggleGlobalLoader,
})(DestinationFullMap)
